/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Rolechangesfailed2Inputs */

const en_settings_collaborators_rolechangesfailed2 = /** @type {(inputs: Settings_Collaborators_Rolechangesfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to save role changes`)
};

/**
* | output |
* | --- |
* | "Failed to save role changes" |
*
* @param {Settings_Collaborators_Rolechangesfailed2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_rolechangesfailed2 = /** @type {((inputs?: Settings_Collaborators_Rolechangesfailed2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Rolechangesfailed2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_rolechangesfailed2(inputs)
});
export { settings_collaborators_rolechangesfailed2 as "settings_collaborators_roleChangesFailed" }